export default "__VITE_ASSET__Di7u8ZlN__"